<div *ngIf="color == 'Green'" class="green"></div>
<div *ngIf="color == 'partial-green'"  class="partial-green"></div>
<div *ngIf="color == 'yellow'" class="yellow"></div>
<div *ngIf="color == 'partial-yellow'" class="partial-yellow"></div>
<div *ngIf="color == 'red'" class="red"></div>
<div *ngIf="color == 'partial-red'" class="partial-red"></div>
<div *ngIf="color == 'partial-grey'" class="partial-grey"></div>
<div *ngIf="color == 'grey-square'" class="grey-square"></div>